var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"table_store":"core/documents/table"},scopedSlots:_vm._u([{key:"status",fn:function(ref){
var item = ref.item;
return [_c('status-badge',{attrs:{"value":item.status}})]}},{key:"preview",fn:function(ref){
var item = ref.item;
return [_c('cell-preview',{attrs:{"item":item}})]}},{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('cell-download',{attrs:{"item":item}})]}}])},[_c('template',{slot:"per-page-select"},[_c('i-button',{attrs:{"size":"large","to":{ name: 'core.document.create' }}},[_vm._v(" "+_vm._s(_vm.$t('core.document.add_btn'))+" ")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }